export default {
    isDisplayOnly: (productVariant) => productVariant?.StockStatus === 'DisplayOnly',
    isComingSoon: (productVariant) =>
        productVariant?.StockStatus === 'DisplayOnly' || productVariant?.StockStatus === 'Preorder',
};
